<!-- Start: Single choice -->
<app-element-container
  [element]="element"
  [index]="index"
  [hasEntries]="hasEntries"
  [allElements]="allElements"
  (remove)="elementRemove.emit(element)"
  (manage)="elementManage.emit(element)"
  (moveUp)="elementMoveUp.emit(element)"
  (moveDown)="elementMoveDown.emit(element)"
  (addMessage)="messageAdd.emit(element)"
  (editMessage)="messageEdit.emit($event)"
  (removeMessage)="messageRemove.emit($event)"
  (visibilityEdit)="visibilityEdit.emit(element)">
  <div class="form-element-answer element-single-choice">
    @for (option of element.options; track option.id) {
      <div class="element-option">
        <input type="checkbox" [value]="option.id" [name]="element.name()" />
        <label>{{ option.text }}</label>
      </div>
    }
  </div>
</app-element-container>
<!-- End: Single choice -->
